import { createContext, useContext, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import notificationSound from "./Assets/Notification Sound.mpeg";

const GlobalContext = createContext();

export function GlobalProvider({ children }) {
  const baseurl =
    process.env.REACT_APP_SALES_API_BASE_URL || "https://api2.packky.com";

  const username =
    process.env.REACT_APP_API_AUTH_USERNAME || "packky@gmail.com";

  const password =
    process.env.REACT_APP_API_AUTH_PASSWORD ||
    "Z90LTO34RTNQGT49LCIYRVTXJERZTKX8";

  const appName = process.env.REACT_APP_APP_NAME || "Packky";

  // const [baseurl] = useState("https://api2.packky.com");
  const audioRef = useRef(new Audio(notificationSound));

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = 0.6;
    }
  }, []);

//   const [AdminId, setAdminId] = useState(() => {
//   const saved = sessionStorage.getItem("admin");
//   return saved ? JSON.parse(saved).userId : null;
// });

const [AdminId, setAdminId] = useState(() => {
  const adminSaved = sessionStorage.getItem("admin");
  if (adminSaved) return JSON.parse(adminSaved).userId;

  const volunteerSaved = sessionStorage.getItem("volunteerData");
  if (volunteerSaved) return JSON.parse(volunteerSaved).userId;

  return null;
});

// const [accessToken, setAccessToken] = useState(() => {
//   const saved = sessionStorage.getItem("admin");
//   return saved ? JSON.parse(saved).accessToken : null;
// });

const [accessToken, setAccessToken] = useState(() => {
  const adminSaved = sessionStorage.getItem("admin");
  if (adminSaved) return JSON.parse(adminSaved).accessToken;

  const volunteerSaved = sessionStorage.getItem("volunteerData");
  if (volunteerSaved) return JSON.parse(volunteerSaved).accessToken;

  return null;
});

 const [admin, setAdmin] = useState(() => {
  const saved = sessionStorage.getItem("admin");
  return saved ? JSON.parse(saved) : null;
});

  const [showOld, setShowOld] = useState(() => {
    const savedView = localStorage.getItem("viewMode");
    return savedView === "task";
  });

  useEffect(() => {
    localStorage.setItem("viewMode", showOld ? "task" : "map");
  }, [showOld]);

  const [isMuted, setIsMuted] = useState(() => {
    const savedMute = localStorage.getItem("notificationMuted");
    return savedMute === "true";
  });

  const toggleMute = () => {
    setIsMuted((prev) => {
      localStorage.setItem("notificationMuted", !prev);
      return !prev;
    });
  };

  const [ApiCall, setApiCall] = useState(false);
  const [IsUnauthorised, setIsUnauthorised] = useState(false);

  // Track if admin data has been loaded from sessionStorage
  const [isAdminLoaded, setIsAdminLoaded] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const savedAdmin = sessionStorage.getItem("admin");

    if (savedAdmin) {
      const adminData = JSON.parse(savedAdmin);
      setAdmin(adminData);
      setAccessToken(adminData.accessToken);
      setAdminId(adminData.userId);
    }

    setIsAdminLoaded(true);
  }, []);

useEffect(() => {
  if (!IsUnauthorised) return;

  const isAdminRoute = window.location.pathname.startsWith("/admin");
  const isVolunteerRoute = window.location.pathname.startsWith("/volunteer");

  if (isAdminRoute) {
    sessionStorage.removeItem("admin");
    setAdmin(null);
    setAccessToken(null);
    navigate("/login", { replace: true });
  }

  if (isVolunteerRoute) {
    sessionStorage.removeItem("volunteerData");
    sessionStorage.removeItem("volunteerToken");
    navigate("/volunteer/login", { replace: true });
  }

  setIsUnauthorised(false);

}, [IsUnauthorised, navigate]);

  useEffect(() => {
    const handleStorageChange = () => {
      const savedAdmin = sessionStorage.getItem("admin");
      if (savedAdmin) {
        const adminData = JSON.parse(savedAdmin);
        setAdmin(adminData);
        setAccessToken(adminData.accessToken);
        setAdminId(adminData.userId);
      } else {
        setAdmin(null);
        setAccessToken(null);
        setAdminId(null);
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  console.log("DistributorId:", AdminId);
console.log("AccessToken:", accessToken);

  // const username = "packky@gmail.com";
  // const password = "Z90LTO34RTNQGT49LCIYRVTXJERZTKX8";
  const token = btoa(`${username}:${password}`);

  const [searchQueryGlobal, setSearchQueryGlobal] = useState("");
  const [drivers, setDrivers] = useState([]);

  const [socketData, setSocketData] = useState(null);
  const socketRef = useRef(null);
  const reconnectTimeout = useRef(null);

  //  Auto-Reconnecting WebSocket
  useEffect(() => {
    if (!admin?.userId) return;

    let reconnectAttempts = 0;
    const maxReconnectAttempts = 5;

    const connectWebSocket = () => {
      const ws = new WebSocket(
        `wss://api2.packky.com/ws?userId=${admin.userId}&roomId=task_room_v1`,
      );
      socketRef.current = ws;

      ws.onopen = () => {
        console.log(`${admin.userId}  WebSocket connected`);
        reconnectAttempts = 0;
      };

      ws.onmessage = (event) => {
        try {
          const message = JSON.parse(event.data);
          console.log(" Socket Message:", message);
          setSocketData(message);
          setApiCall((prev) => !prev);

          // Play notification sound only if not muted
          if (!isMuted && audioRef.current) {
            audioRef.current.currentTime = 0;
            audioRef.current.play().catch((err) => {
              console.warn(
                "Notification sound blocked until user interacts",
                err,
              );
            });
          }
        } catch (e) {
          console.error(" Failed to parse socket message", e);
        }
      };

      ws.onerror = (err) => {
        console.error(" WebSocket error:", err);
        ws.close(); // Force close to trigger reconnect
      };

      ws.onclose = () => {
        console.warn(" WebSocket disconnected");

        if (reconnectAttempts < maxReconnectAttempts) {
          const delay = Math.min(1000 * 2 ** reconnectAttempts, 10000); // Exponential backoff
          console.log(` Reconnecting in ${delay / 1000}s...`);
          reconnectTimeout.current = setTimeout(connectWebSocket, delay);
          reconnectAttempts++;
        } else {
          console.error(" Max reconnect attempts reached.");
        }
      };
    };

    connectWebSocket();

    return () => {
      if (socketRef.current) socketRef.current.close();
      clearTimeout(reconnectTimeout.current);
    };
  }, [admin?.userId, isMuted]);

  return (
    <GlobalContext.Provider
      value={{
        baseurl,
        appName,
        token,
        searchQueryGlobal,
        setSearchQueryGlobal,
        accessToken,
        setAccessToken,
        ApiCall,
        setApiCall,
        setIsUnauthorised,
        IsUnauthorised,
        socketData,
        AdminId,
        setAdminId,
        isMuted,
        toggleMute,
        showOld,
        setShowOld,
        admin,
        setAdmin,
        drivers,
        setDrivers,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
}

export function useGlobalContext() {
  return useContext(GlobalContext);
}
